<script setup>
import { computed, provide } from 'vue'
import { buildVisibleTree, componentMap } from '@/Components/Navigation'

const props = defineProps({
  items: {
    required: true,
    default: {},
  },
})

const items = computed(() => {
  if (Array.isArray(props.items)) {
    return props.items
  }

  return buildVisibleTree(props.items, 'mobile')
})

provide('viewport', 'mobile')
</script>

<template>
  <div class="flex flex-col gap-2">
    <Component
      v-for="item in items"
      :key="item.id"
      :is="componentMap[item.component]"
      v-bind="item"
    />
  </div>
</template>
